import { useEffect, useState } from 'react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

export default function useServiceWorkerUpdater() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        setWaitingWorker(registration.waiting);
        setShowReload(true);
      }
    });
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload();
  };

  return { showReload, reloadPage };
}
